import api from "./api";

// Fetch all drivers
export const fetchAllDrivers = async () => {
  try {
    const response = await api.get('/driver-management/drivers');
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching drivers:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch drivers" };
  }
};

// Update driver status
export const updateDriverStatus = async (driverId, status, statusReason = null) => {
  try {
    const payload = { status, ...(statusReason && { status_reason: statusReason }) };

    const response = await api.put(`/driver-management/drivers/${driverId}/status`, payload);

    if (response.status === 200 && response.data.success) {
      const driverData = response.data.data;
     

      return {
        success: true,
        data: { ...driverData, id: driverData.driver_id },
      };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error("Error updating driver status:", error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to update driver status",
    };
  }
};

